import React from "react";
import { Space } from "antd";
import { AxSearch, AxIconWrapper, AxDivider, AxButton } from "@dynata/axiom3";

class Search extends React.Component {
  render() {
    return (
      <div className="section" id="search">
        <h3>Search</h3>
        <p>Search input compontent.</p>
        <AxDivider orientation="left" plain>
          Basic Usage
        </AxDivider>
        <Space direction="vertical">
          <Space size="large" direction="vertical">
            <pre>{`<AxSearch placeholder="AxSearch" />`}</pre>
            <div className="prop-header">
              <p className="props-title">Props</p>
              <p>
                For AntD props, visit{" "}
                <AxButton
                  size="small"
                  type="link"
                  target="_blank"
                  href="https://ant.design/components/input/#Input.Search"
                >
                  https://ant.design/components/input/#Input.Search
                </AxButton>
              </p>
            </div>

            <table className="props-table">
              <thead>
                <tr>
                  <th>Property</th>
                  <th>Description</th>
                  <th>Type</th>
                  <th>Default</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>size</td>
                  <td>Size of search input, default is medium</td>
                  <td>small | medium | large | xlarge</td>
                  <td></td>
                </tr>
                <tr>
                  <td>enterButton</td>
                  <td>Whether to show an enter button after input.</td>
                  <td>boolean</td>
                  <td></td>
                </tr>

                <tr>
                  <td>enterButton</td>
                  <td>Custom text for serach button</td>
                  <td>enterButton="Search"</td>
                  <td></td>
                </tr>

                <tr>
                  <td>enterButton</td>
                  <td>Whether to show an enter button after input.</td>
                  <td>boolean</td>
                  <td></td>
                </tr>

                <tr>
                  <td>suffix</td>
                  <td>
                    Whether to render an icon before the Serach button.
                    AxIconWrapper with all custom properties can be used here
                  </td>
                  <td>
                    <pre>{`suffix={<AxIconWrapper type="regular" size="16" icon={"fa-microphone"} />}`}</pre>
                  </td>
                </tr>
                <tr>
                  <td>enterButton</td>
                  <td>
                    Whether to show an enter button after input. This property
                    conflicts with the <code>addonAfter</code> property
                  </td>
                  <td>boolean | ReactNode</td>
                  <td>false</td>
                </tr>
                <tr>
                  <td>loading</td>
                  <td>Search box with loading</td>
                  <td>boolean</td>
                  <td>false</td>
                </tr>
                <tr>
                  <td>onSearch</td>
                  <td>
                    The callback function triggered when you click on the
                    search-icon, the clear-icon or press the Enter key
                  </td>
                  <td>function(value, event)</td>
                  <td>-</td>
                </tr>
                <tr>
                  <td>...others</td>
                  <td>
                    All extra props are passed down to the{" "}
                    <>
                      <AxButton
                        size="small"
                        type="link"
                        target="_blank"
                        href="https://4x.ant.design/components/input/#Input.Search"
                      >
                        {`<Input.Search />`}
                      </AxButton>
                    </>{" "}
                    component.
                  </td>
                  <td></td>
                  <td>-</td>
                </tr>
              </tbody>
            </table>
          </Space>
        </Space>

        <AxDivider orientation="left" plain>
          Default
        </AxDivider>

        <Space align="start">
          <Space direction="vertical">
            <AxSearch placeholder="AxSearch" size="small" />
            <AxSearch placeholder="AxSearch" />
            <AxSearch placeholder="AxSearch" disabled />
            <AxSearch placeholder="AxSearch" size="large" />
            <AxSearch placeholder="AxSearch" size="xlarge" />
          </Space>

          <Space direction="vertical">
            <AxSearch placeholder="AxSearch" size="small" enterButton />
            <AxSearch placeholder="AxSearch" enterButton />
            <AxSearch placeholder="AxSearch" size="large" enterButton />
            <AxSearch placeholder="AxSearch" size="xlarge" enterButton />
          </Space>

          <Space direction="vertical">
            <AxSearch
              placeholder="AxSearch"
              size="small"
              enterButton="Search"
            />
            <AxSearch placeholder="AxSearch" enterButton="Search" />
            <AxSearch
              placeholder="AxSearch"
              size="large"
              enterButton="Search"
            />
            <AxSearch
              placeholder="AxSearch"
              size="xlarge"
              enterButton="Search"
            />
          </Space>

          <Space direction="vertical">
            <AxSearch
              placeholder="AxSearch"
              size="small"
              enterButton="Search"
              suffix={
                <AxIconWrapper
                  type="regular"
                  size="16"
                  icon={"fa-microphone"}
                />
              }
            />
            <AxSearch
              placeholder="AxSearch"
              enterButton="Search"
              suffix={
                <AxIconWrapper
                  type="regular"
                  size="16"
                  icon={"fa-microphone"}
                />
              }
            />
            <AxSearch
              placeholder="AxSearch"
              size="large"
              enterButton="Search"
              suffix={
                <AxIconWrapper
                  type="regular"
                  size="18"
                  icon={"fa-microphone"}
                />
              }
            />
            <AxSearch
              placeholder="AxSearch"
              size="xlarge"
              enterButton="Search"
              suffix={
                <AxIconWrapper
                  type="regular"
                  size="18"
                  icon={"fa-microphone"}
                />
              }
            />
          </Space>
        </Space>
      </div>
    );
  }
}
export default Search;
